// import { MenuItem, FormControl, InputLabel, Select, Box } from "@material-ui/core";
import {
  MenuItem,
  // OutlinedInput,
  // InputLabel,
  // FormControl,
  // ListItemText,
  // Checkbox,
  Select,
  // Chip,
  // Box,
} from "@material-ui/core";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import { useState } from "react";

const SelectService = ({ options, handleServiceChange, index, reserve, handleTotalValueChange, errorService }) => {
  const [type, setType] = useState(reserve?.products);
  const handleType = (event) => {
    setType(event.target.value);
    handleServiceChange(event, index);
    handleTotalValueChange(event.target.value, index);
  };
  return (
    <>
      <div className="d-flex mb-4 ">
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label" style={{ paddingTop: "5px" }}>
            Serviços
          </InputLabel>
          <Select
            MenuProps={{
              variant: "menu",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            }}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="products"
            value={type}
            label="Serviços"
            onChange={handleType}
            error={errorService}
            input={<OutlinedInput label="label" className="fz-16 text-cl-dark-jungle-green ff-univanova p-1" />}
            required
          >
            {options.map((option) => (
              <MenuItem key={option.id} value={option}>
                {option.name + "  -"}
                {" R$ " + parseFloat(option.price).toFixed(2).replace(".", ",")}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </>
  );
};

export default SelectService;
